export { default } from './EventLocations';
